import Image from 'next/image'
import { FC } from 'react'

import fasLogo from '@/assets/images/common/logo_fas.svg'
import FooterGenreLinks from '@/components/Layout/Footer/Molecules/FooterGenreLinks'
import '@/components/Layout/Footer/Organisms/FooterLinksUnion/FooterLinksUnion.scss'
import ULink from '@/components/Link/ULink'
import { productGroups } from '@/components/Page/Product/ProductsPage'
import { instagramRedirectPath, lineFriendRedirectPath, twitterUrl } from '@/utils/const'

const UNIONS = {
  products: {
    headingText: 'Product',
    items: [
      {
        text: 'All Products',
        href: '/products/',
      },
      ...productGroups.map((productGroup) => {
        const text = productGroup
          .split(' ')
          .map((partOfName: string) => `${partOfName.substring(0, 1).toUpperCase()}${partOfName.substring(1)}`)
          .join(' ')
        const path = productGroup.replaceAll(' ', '')
        return {
          text,
          href: `/products/groups/${path}`,
        }
      }),
    ],
  },
  information: {
    headingText: 'Information',
    items: [
      {
        text: 'News',
        href: '/news/',
      },
      {
        text: 'Topics',
        href: '/topics/',
      },
      {
        text: 'Journal',
        href: '/journals/',
      },
    ],
  },
  social: {
    headingText: 'Social',
    items: [
      {
        text: 'Instagram',
        href: instagramRedirectPath,
      },
      {
        text: 'Line',
        href: lineFriendRedirectPath,
      },
      {
        text: 'Twitter',
        href: twitterUrl,
      },
    ],
  },
  about: {
    headingText: 'About',
    items: [
      {
        text: 'About FAS',
        href: '/about/',
      },
      {
        text: 'Store',
        href: '/store/',
      },
      {
        text: 'Contact',
        href: 'https://sirok.jp/inquiry/new',
      },
    ],
  },
  mypage: {
    headingText: 'Mypage',
    items: [
      {
        text: 'Login',
        href: '/sign-in/',
      },
    ],
  },
} as const

const FooterLinksUnion: FC = () => {
  return (
    <div className="l-footer-linksUnion">
      <ULink nextLink={false} href="/" className="l-footer-linksUnion__logo">
        <Image
          className="l-footer-linksUnion__logo-image"
          src={fasLogo.src}
          alt="FAS"
          width={fasLogo.width}
          height={fasLogo.height}
        />

        <p className="l-footer-linksUnion__logo-catch">
          Fermentation &amp;
          <br />
          Science
        </p>
      </ULink>

      <div className="l-footer-linksUnion__links">
        {Object.values(UNIONS).map((union, i) => {
          return (
            <FooterGenreLinks
              key={`${union.headingText}-${i}`}
              className="l-footer-linksUnion__links-children"
              items={union.items}
              headingText={union.headingText}
            />
          )
        })}
      </div>
    </div>
  )
}

export default FooterLinksUnion
